// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3JI7S","range":"MonthRangeSwitch_range__46E77","disabled":"MonthRangeSwitch_disabled__3dgbV"};